import React from 'react';
import { getFestival, getProgram } from '../../data/loadData';
import { dateRange, parseDay, upper } from '../../data/dates';
import './FestivalHero.css';

function splitName(name) {
    const match = String(name || '').match(/^(\d+)\.\s*(.*)$/);
    return match ? { number: `${match[1]}.`, rest: match[2] } : { number: '', rest: String(name || '') };
}

export default function FestivalHero({ year, title, poster }) {
    const festival = getFestival(year);
    const days = (getProgram(year).dates || []).map(parseDay).filter((day) => day.day);
    const range = dateRange(days) || String(year);
    const { number, rest } = splitName(festival.name);
    const posterSrc = poster || festival.poster || `images/festivals/${festival.id}/${festival.logo || 'logo.png'}`;

    const goToProgram = (event) => {
        const target = document.getElementById(`program-${year}`);
        if (!target) return;
        event.preventDefault();
        const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    };

    return (
        <section className="hero-area hero-ethos" lang="tr">
            <div className="hero-ethos-bg" style={{ backgroundImage: "url(images/banner/banner.jpg)" }} aria-hidden="true"></div>
            <div className="container hero-ethos-row">
                <div className="hero-ethos-text">
                    <h1 className="hero-ethos-title">
                        {number ? <span className="hero-ethos-num">{number}</span> : null}
                        <span className="hero-ethos-name">{upper(title || rest || 'Ethos Ankara Tiyatro Festivali')}</span>
                    </h1>
                    {festival.theme ? (
                        <p className="hero-ethos-theme">
                            <span className="hero-ethos-theme-label">Ana tema</span>
                            {festival.theme}
                        </p>
                    ) : null}
                    <div className="hero-ethos-actions">
                        <p className="hero-ethos-date">{upper(range)}</p>
                        <a className="hero-ethos-cta" href={`#program-${year}`} onClick={goToProgram}>
                            Programı incele <span aria-hidden="true">↓</span>
                        </a>
                    </div>
                </div>
                <figure className="hero-ethos-poster">
                    <img src={posterSrc} alt={`${festival.name || 'Ethos Tiyatro Festivali'} afişi`} />
                </figure>
            </div>
        </section>
    );
}
